import React, { useContext, useEffect, useCallback } from 'react';
import useStyles from './Panel.styles';
import SideMenu from '../../components/SideMenu/SideMenu';
import PanelHeader from '../../components/PanelHeader/PanelHeader';
import { Box, CircularProgress } from '@material-ui/core';
import PrivateRoutes from '../../Routes/PrivateRoutes';
import { SessionContext } from '../../contexts/session/SessionContext';
import { useHistory } from 'react-router-dom';
import { EPaths } from '../../types/enums/EPaths';
import { ESessionStorageKeys } from '../../types/enums/ESessionStorageKeys';

const Panel = () => {
  const styles = useStyles();
  const { token, updateToken, permissionsLoaded } = useContext(SessionContext);
  const history = useHistory();

  const handleIfTokenEmpty = useCallback(() => {
    const token = sessionStorage.getItem(ESessionStorageKeys.Token);
    if (token) {
      updateToken(token);
      return;
    }
    history.replace(EPaths.Login);
  }, [history, updateToken]);

  useEffect(() => {
    
    if (!token) handleIfTokenEmpty();
    
  }, [handleIfTokenEmpty, history, token]);

  return (
    <>
      <PanelHeader />
      <Box className={styles.notHeader}>
        <Box>
          <SideMenu />
        </Box>
        <Box className={styles.content}>
          {permissionsLoaded ? <PrivateRoutes /> : <CircularProgress />}
        </Box>
      </Box>
    </>
  );
};

export default Panel;
